import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { TaskTemplateType } from '@econtractor/types';
import ESpinner from 'components/others/Spinner';
import TaskDirTable from '../TaskDir/TaskDirTable';
import { TaskCategoryFilterSelect } from '../TaskCategory/TaskCategoryFilter';

interface NewTaskTemplatePickerProps {
    searchInput: string;
    setSearchInput: (value: string) => void;
    categoryId: number | null;
    setFilterCategoryId: (categoryId: number | null) => void;
    templates: TaskTemplateType[] | null;
    showSpinner: boolean;
    onSelect: (template: TaskTemplateType) => void;
}

const NewTaskTemplatePicker = ({
    searchInput,
    setSearchInput,
    categoryId,
    setFilterCategoryId,
    templates,
    showSpinner,
    onSelect,
}: NewTaskTemplatePickerProps) => {
    const { t } = useTranslation('Tasks');

    return (
        <>
            <Form.Control
                className="mb-3"
                value={searchInput}
                placeholder={t('directory.search')}
                onChange={(e) => setSearchInput(e.target.value)}
            />
            <div className="mb-3">
                <TaskCategoryFilterSelect
                    filterCategoryId={categoryId}
                    setFilterCategoryId={setFilterCategoryId}
                />
            </div>
            {templates == null ? (
                <ESpinner />
            ) : (
                <TaskDirTable
                    templates={templates}
                    showSpinner={showSpinner}
                    hideExecutor
                    onSelect={onSelect}
                />
            )}
        </>
    );
};

export default NewTaskTemplatePicker;
